import { MatchLabelMap } from '../constants/MatchLabelMap';
import type { AssetResultMatch } from '../types';

export const getMatchLabel = (match: AssetResultMatch) => {
  const getLabel =
    MatchLabelMap[
      match.__typename as NonNullable<AssetResultMatch['__typename']>
    ];
  const params =
    match.__typename === 'VisualMatch'
      ? { count: match?.clips?.length || 1 }
      : undefined;

  return getLabel?.(params);
};
